export const CROPS_CONTEXT_ACTION_TYPES = {
  CROP_ADDED: 'crop-added',
  CROP_EDITED: 'crop-edited',
  CROP_REMOVED: 'crop-removed',
  PLOT_ADDED: 'plot-added',
  PLOT_EDITED: 'plot-edited',
  PLOT_REMOVED: 'plot-removed',
  TASK_ADDED: 'task-added',
  TASK_EDITED: 'task-edited',
  TASK_REMOVED: 'task-removed',
  REPORT_ADDED: 'report-added',
  REPORT_UPDATED: 'report-updated',
  REPORT_REMOVED: 'report-removed',
}

export const initialState = {
  // Counter that increments on any crop change, used to trigger re-fetches
  refreshKey: 0,
  // Last event info for consumers that need details
  lastEvent: null,
  // Last task update for optimistic updates (observed via useEffect)
  lastTaskUpdate: null,
}

export function CropsContextReducer(state, action) {
  switch(action.type) {
    case CROPS_CONTEXT_ACTION_TYPES.CROP_ADDED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'added', cropId: action.cropId, timestamp: Date.now() }
      }

    case CROPS_CONTEXT_ACTION_TYPES.CROP_EDITED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'edited', cropId: action.cropId, timestamp: Date.now() }
      }

    case CROPS_CONTEXT_ACTION_TYPES.CROP_REMOVED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'removed', cropId: action.cropId, timestamp: Date.now() }
      }

    case CROPS_CONTEXT_ACTION_TYPES.PLOT_ADDED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'added', plotId: action.plotId, timestamp: Date.now() }
      }

    case CROPS_CONTEXT_ACTION_TYPES.PLOT_EDITED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'edited', plotId: action.plotId, timestamp: Date.now() }
      }

    case CROPS_CONTEXT_ACTION_TYPES.PLOT_REMOVED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'removed', plotId: action.plotId, timestamp: Date.now() }
      }

    case CROPS_CONTEXT_ACTION_TYPES.TASK_ADDED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'added', taskId: action.taskId, timestamp: Date.now() }
      }

    case CROPS_CONTEXT_ACTION_TYPES.TASK_EDITED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'edited', plotId: action.taskId, timestamp: Date.now() },
      }

    case CROPS_CONTEXT_ACTION_TYPES.TASK_REMOVED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'removed', taskId: action.taskId, timestamp: Date.now() }
      }

    case CROPS_CONTEXT_ACTION_TYPES.REPORT_ADDED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'added', reportId: action.reportId, timestamp: Date.now() }
      }

    case CROPS_CONTEXT_ACTION_TYPES.REPORT_UPDATED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'updated', reportId: action.reportId, timestamp: Date.now() }
      }

    case CROPS_CONTEXT_ACTION_TYPES.REPORT_REMOVED:
      return {
        ...state,
        refreshKey: state.refreshKey + 1,
        lastEvent: { type: 'removed', reportId: action.reportId, timestamp: Date.now() }
      }

    default: {
      throw new Error('Unknown action sent to CropsContextReducer:', action.type)
    }
  }
}
